import { createApi } from '@/api/modules/utils'

const baseUrl = '/all_article'
const api = createApi(baseUrl)

// 已发布文章列表
export const allArticleApi = {
  list: api('list', 'get'),
  detail: api('detail', 'get'),
  push: api('push', 'get'),
}